export default "__VITE_ASSET__D$$45jjW__"